import { gql } from '@apollo/client';

export const CREATE_VALDITY = gql`
  mutation createValidity($createValidityInput: CreateValidityInput!) {
    createValidity(createValidityInput: $createValidityInput) {
      id
      productId
      subProductId
      productFullDescription
      productShortDescription
      barcodeNumber
      sectionId
      sectionDescription
      branchCode
      branchName
      validity
      exitPackaging
      quantity
      statusName
      statusColor
      observation
      priority
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_VALDITY = gql`
  mutation updateValidity($updateValidityInput: UpdateValidityInput!) {
    updateValidity(updateValidityInput: $updateValidityInput) {
      id
      productId
      subProductId
      productFullDescription
      productShortDescription
      barcodeNumber
      sectionId
      sectionDescription
      branchCode
      branchName
      validity
      exitPackaging
      quantity
      statusName
      statusColor
      observation
      priority
      createdAt
      updatedAt
    }
  }
`;

export const FILTER_VALDITIES = gql`
  query filterValidities($searchFilter: SearchFilter!) {
    filterValidities(searchFilter: $searchFilter) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        productId
        subProductId
        productFullDescription
        productShortDescription
        barcodeNumber
        sectionId
        sectionDescription
        branchCode
        branchName
        validity
        exitPackaging
        quantity
        statusName
        statusColor
        observation
        priority
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_VALIDITIES = gql`
  mutation deleteValidities($validityIds: [String!]!) {
    deleteValidities(validityIds: $validityIds) {
      count
    }
  }
`;

export const AUTOCOMPLETE_VALIDITIES = gql`
  query autocompleteValidities($autocompleteFilter: AutocompleteFilter!) {
    autocompleteValidities(autocompleteFilter: $autocompleteFilter) {
      data {
        id
        value
      }
    }
  }
`;

export const CREATE_VALDITY_STATUS = gql`
  mutation createValidityStatus(
    $createValidityStatusInput: CreateValidityStatusInput!
  ) {
    createValidityStatus(
      createValidityStatusInput: $createValidityStatusInput
    ) {
      id
      name
      color
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_VALDITY_STATUS = gql`
  mutation updateValidityStatus(
    $updateValidityStatusInput: UpdateValidityStatusInput!
  ) {
    updateValidityStatus(
      updateValidityStatusInput: $updateValidityStatusInput
    ) {
      id
      name
      color
      createdAt
      updatedAt
    }
  }
`;

export const FILTER_VALDITY_STATUS = gql`
  query filterValidityStatus($searchFilter: SearchFilter!) {
    filterValidityStatus(searchFilter: $searchFilter) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        name
        color
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_VALIDITY_STATUS = gql`
  mutation deleteValidityStatus($validityStatusIds: [String!]!) {
    deleteValidityStatus(validityStatusIds: $validityStatusIds) {
      count
    }
  }
`;

export const AUTOCOMPLETE_VALIDITY_STATUS = gql`
  query autocompleteValidityStatus($autocompleteFilter: AutocompleteFilter!) {
    autocompleteValidityStatus(autocompleteFilter: $autocompleteFilter) {
      data {
        id
        value
      }
    }
  }
`;
